"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compare = void 0;
const apply_1 = require("./apply");
const defaultFormatter = ({ key, isArrayMember: isArr }) => isArr ? `[${key}]` : `.${key}`;
function compare(a, b, leavesOnly = false, formatter = defaultFormatter, nodeComparison = (a, b) => Object.is(a.val, b.val)) {
    const aNodes = {};
    const bNodes = {};
    (0, apply_1.apply)(a, n => aNodes[n.getPath(formatter)] = n);
    (0, apply_1.apply)(b, n => bNodes[n.getPath(formatter)] = n);
    return [...new Set([
            ...Object.keys(aNodes),
            ...Object.keys(bNodes)
        ])]
        .filter(key => !leavesOnly || (aNodes[key] || bNodes[key]).nodeType === 'value')
        .map(key => {
        const aNode = aNodes[key];
        const bNode = bNodes[key];
        const removed = aNode && !bNode;
        const added = bNode && !aNode;
        const changed = aNode && bNode && !nodeComparison(aNode, bNode);
        let delta = {
            path: key,
            hasDifference: removed || added || changed
        };
        if (added) {
            delta.difference = 'added';
            delta.b = bNode === null || bNode === void 0 ? void 0 : bNode.val;
        }
        else if (removed) {
            delta.difference = 'removed';
            delta.a = aNode === null || aNode === void 0 ? void 0 : aNode.val;
        }
        else if (changed) {
            delta.difference = {
                before: aNode === null || aNode === void 0 ? void 0 : aNode.val,
                after: bNode === null || bNode === void 0 ? void 0 : bNode.val
            };
            delta.a = aNode === null || aNode === void 0 ? void 0 : aNode.val;
            delta.b = bNode === null || bNode === void 0 ? void 0 : bNode.val;
        }
        return delta;
    });
}
exports.compare = compare;
